module.exports = __webpack_public_path__ + "static/media/hockey-sticks.a13319fa.svg";